
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store';

import i18n from './i18n';
import axios from './axios'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './moment'
Vue.prototype.$http = axios


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import './../node_modules/slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
Vue.use(Toast);

Vue.prototype.$http.defaults.withCredentials = true;

Vue.use(FloatingVue)

new Vue({
	router:router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app')
